import axios from 'axios';
import https from 'https';

import { checkShouldUseMocks } from '../envUtils';
import { isSSR } from '../helpers';

const readHybrisInternalCA = () => {
    const hybrisInternalCA = process.env.HYBRIS_INTERNAL_CA_CERT;
    if (hybrisInternalCA) {
        try {
            return Buffer.from(hybrisInternalCA, 'base64');
        } catch {
            // No op
        }
    }

    return null;
};

const getSSRHttpsAgent = () => {
    const hybrisInternalCA = readHybrisInternalCA();

    return new https.Agent({
        ca: hybrisInternalCA ? hybrisInternalCA : undefined,
        rejectUnauthorized: !hybrisInternalCA ? false : undefined,
    });
};

export const axiosForHybris = axios.create(
    isSSR()
        ? {
              httpsAgent: getSSRHttpsAgent(),
              baseURL: process.env.HYBRIS_INTERNAL_URL,
          }
        : {
              httpsAgent: undefined,
              baseURL: checkShouldUseMocks() ? process.env.HYBRIS_PUBLIC_URL : '',
          },
);
